// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleScanJobRunner = {
  id: "scan-job-runner",
  mrn: "//iam.api.mondoo.app/roles/scan-job-runner",
  title: "Scan Job Runner",
  allowedActions,
} as const;

export type RoleScanJobRunner = typeof roleScanJobRunner;
